/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Open_PageInputs */



/**
* | output |
* | --- |
* | "Open page" |
*
* @param {Chat_Activity_Open_PageInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_open_page = /** @type {((inputs?: Chat_Activity_Open_PageInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Open_PageInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Open pagina")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la page")
	return /** @type {LocalizedString} */ ("Open page")
});